var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 98,
    height: 44,
    viewBox: "-20.5 0 297 297",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    preserveAspectRatio: "xMidYMid",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M174.656,28.438 L125.717,0 L74.646,31.723 L124.267,59.137 L174.656,28.438 L174.656,28.438 Z M198.059,40.683 L147.52,71.424 L204.8,104.533 L204.8,192 L127.552,235.904 L51.2,192 L51.2,123.733 L0,98.304 L0,221.867 L125.717,296.533 L256,222.422 L256,74.155 L198.059,40.683 L198.059,40.683 Z",
    fill: "#2396F3"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo1);
export default __webpack_public_path__ + "static/media/logo1.f98d722ebd5172b863deaa8b0e5681f1.svg";
export { ForwardRef as ReactComponent };